import {
  CmsFormState,
  Genders,
  InvoiceState,
  NoteType,
  Pronouns,
  TranscriptNoteType,
} from '@graphQLGenerated'

export const genderOptions = [
  {
    label: '',
    value: '',
  },
  {
    label: 'Female',
    value: Genders.Female,
  },
  {
    label: 'Male',
    value: Genders.Male,
  },
  {
    label: 'Non binary',
    value: Genders.NonBinary,
  },
  {
    label: 'Prefer not to answer',
    value: Genders.PreferNotToAnswer,
  },
]

export const sexOptions = [
  {
    label: '',
    value: '',
  },
  {
    label: 'Female',
    value: Genders.Female,
  },
  {
    label: 'Male',
    value: Genders.Male,
  },
]

export const pronounOptions = [
  {
    label: '',
    value: '',
  },
  {
    label: 'He/Him',
    value: Pronouns.HeHim,
  },
  {
    label: 'She/Her',
    value: Pronouns.SheHer,
  },
  {
    label: 'They/Them',
    value: Pronouns.TheyThem,
  },
  {
    label: 'Prefer not to answer',
    value: Pronouns.PreferNotToAnswer,
  },
]

export const transcriptNoteTypeOptions = [
  {
    label: 'SOAP',
    value: TranscriptNoteType.Soap,
  },
  {
    label: 'DAP',
    value: TranscriptNoteType.Dap,
  },
  {
    label: 'SIRP',
    value: TranscriptNoteType.Sirp,
  },
  {
    label: 'BIRP',
    value: TranscriptNoteType.Birp,
  },
  {
    label: 'Intake Notes',
    value: TranscriptNoteType.Intake,
  },
]

export const DROP_DOWN_REGEX = /^\d+\s*(hrs?|hr|min|mins)\s*(\d+\s*(mins?)?)?$/

export const InvoiceStateArray = Object.values(InvoiceState)

export const paymentOptions = [
  {
    label: 'Cash',
    value: 'CASH',
  },
  {
    label: 'Bank payment',
    value: 'BANK_PAYMENT',
  },
  {
    label: 'Check',
    value: 'CHECK',
  },
  {
    label: 'Paypal',
    value: 'PAYPAL',
  },
  {
    label: 'other',
    value: 'OTHER',
  },
]

export const sessionStatusArray = [
  {
    label: 'On',
    value: 'ON',
  },
  {
    label: 'Canceled',
    value: 'CANCELED',
  },
  {
    label: 'Late Canceled',
    value: 'LATE_CANCELED',
  },
  {
    label: 'No Show Up',
    value: 'NO_SHOW_UP',
  },
]

export const CMSFormStateOptions = [
  {
    label: 'Draft',
    value: CmsFormState.Draft,
  },
  {
    label: 'On Hold',
    value: CmsFormState.OnHold,
  },
  {
    label: 'Ready',
    value: CmsFormState.Ready,
  },
  {
    label: 'Submitted',
    value: CmsFormState.Submitted,
  },
]

export const noteTypeOptions = [
  {
    label: 'Note',
    value: NoteType.Text,
  },
  {
    label: 'Progress Note',
    value: NoteType.ProgressNote,
  },
  {
    label: 'Treatment Plan',
    value: NoteType.TreatmentPlan,
  },
]

export const progressNoteDefaultText = `**Subjective:**

-
**Objective:**
- Appearance:
- Psychomotor agitation/retardation:
- Speech:
- Eye contact:
- Affect:
- Mood:
- Thought content:
- Thought process:
- Insight:
- Judgement:
- Cognition:

**Assessment:**

- 

**Plan:**

- 
`

export const treatmentPlanDefaultText = `- **Diagnosis / Persisting Problem / Behavioral Definition:**

- **Long Term Goals:**

- **Objectives / Interventions / Actions:**

- **Strengths / Resources:**

- **Other Relevant Information:**
`

export const passwordRegex =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*\d)(?=.*?[`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~])[A-Za-z\d`!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]+$/

export const promptTypes = ['Worksheet', 'Assessment', 'Technique']
export const promptAudiences = ['Adult', 'Teen', 'Parent', 'Female', 'Male']
export const promptTopics = [
  'Addiction',
  'Abandonment',
  'Anger',
  'Anxiety',
  'Bipolar Disorder',
  'Breakup',
  'Communication',
  'Depression',
  'Eating Disorder ',
  'Executive Functioning',
  'Fatigue ',
  'Friendship',
  'Grief',
  'Insomnia',
  'Mood',
  'OCD',
  'Pain',
  'Perfectionism',
  'Positive Psychology',
  'Romantic Conflict',
  'Self-Harm',
  'Self-Talk',
  'Sleep',
  'Social Anxiety',
  'Stress',
  'Trauma',
  'Vulnerability',
]
export const promptExamples = [
  'Create a CBT therapy worksheet for adults with social anxiety, featuring a thought record to assess thought patterns showcasing the cognitive distortion of Black-and-White Thinking, including reflective questions.',
  'Create a mindfulness therapy worksheet for young adults with generalized anxiety, featuring exercises to identify and focus on present-moment experiences. Include a script that they can read out loud to themselves.',
  'Create a solution-focused therapy worksheet for couples experiencing relationship issues, featuring goal-setting exercises to identify and work towards positive relationship changes.',
  'Create a comprehensive assessment for adults experiencing burnout, assessing their symptoms of burnout over the last two weeks.',
  'Create a brief assessment for young adults, evaluating the extent to which they struggle with emotional regulation.',
]

export const pricing = {
  yearly: 249,
  monthly: 39,
}

export const gracePeriodInDays = 5

export const diagnosisList = [
  'Acute Stress Disorder',
  'Adjustment Disorders',
  'Agoraphobia',
  'Alcohol Use Disorder',
  'Anorexia Nervosa',
  'Antisocial Personality Disorder',
  'Attention-Deficit/Hyperactivity Disorder (ADHD)',
  'Autism Spectrum Disorder (ASD)',
  'Avoidant Personality Disorder',
  'Avoidant/Restrictive Food Intake Disorder (ARFID)',
  'Binge-Eating Disorder',
  'Bipolar I Disorder',
  'Bipolar II Disorder',
  'Body Dysmorphic Disorder',
  'Borderline Personality Disorder',
  'Brief Psychotic Disorder',
  'Bulimia Nervosa',
  'Cannabis Use Disorder',
  'Circadian Rhythm Sleep-Wake Disorders',
  'Communication Disorders (e.g., Speech Sound Disorder, Language Disorder)',
  'Conduct Disorder',
  'Conversion Disorder (Functional Neurological Symptom Disorder)',
  'Cyclothymic Disorder',
  'Delirium',
  'Delusional Disorder',
  'Dependent Personality Disorder',
  'Disinhibited Social Engagement Disorder',
  'Disruptive Mood Dysregulation Disorder',
  'Erectile Disorder',
  'Excoriation (Skin-Picking) Disorder',
  'Exhibitionistic Disorder',
  'Factitious Disorder',
  'Female Orgasmic Disorder',
  'Fetishistic Disorder',
  'Gambling Disorder',
  'Gender Dysphoria in Adolescents and Adults',
  'Gender Dysphoria in Children',
  'Generalized Anxiety Disorder (GAD)',
  'Genito-Pelvic Pain/Penetration Disorder',
  'Hoarding Disorder',
  'Hypersomnolence Disorder',
  'Illness Anxiety Disorder',
  'Insomnia Disorder',
  'Intellectual Developmental Disorder',
  'Intermittent Explosive Disorder',
  'Kleptomania',
  'Major Depressive Disorder (MDD)',
  'Major Neurocognitive Disorder (e.g., Dementia)',
  'Male Hypoactive Sexual Desire Disorder',
  'Mild Neurocognitive Disorder (e.g., Early-Stage Dementia)',
  'Narcolepsy',
  'Narcissistic Personality Disorder',
  'Obsessive-Compulsive Disorder (OCD)',
  'Obsessive-Compulsive Personality Disorder (OCPD)',
  'Obstructive Sleep Apnea',
  'Opioid Use Disorder',
  'Oppositional Defiant Disorder (ODD)',
  'Other Specified Mental Disorder',
  'Panic Disorder',
  'Paranoid Personality Disorder',
  'Pedophilic Disorder',
  'Persistent Depressive Disorder (Dysthymia)',
  'Pica',
  'Post-Traumatic Stress Disorder (PTSD)',
  'Premenstrual Dysphoric Disorder',
  'Pyromania',
  'Reactive Attachment Disorder',
  'Schizoaffective Disorder',
  'Schizoid Personality Disorder',
  'Schizophrenia',
  'Schizotypal Personality Disorder',
  'Sexual Sadism Disorder',
  'Social Anxiety Disorder',
  'Somatic Symptom Disorder',
  'Specific Learning Disorders (e.g., Dyslexia, Dyscalculia)',
  'Specific Phobias',
  'Stimulant Use Disorder',
  'Trichotillomania (Hair-Pulling Disorder)',
  'Unspecified Mental Disorder',
  'Voyeuristic Disorder',
]
